import { handleActions } from "redux-actions";

import { setStatusType } from "./actions";

const initialState = {
    isLoadingStatusType: false,
    statusTypes: {},
    codes: []
};

export const statusTypeReducer = handleActions(
    {
        [setStatusType]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);